import { InstrumentInterestAccrualReducerDispatch, InstrumentInterestAccrualReduxState, InstrumentInterestAccrualReduxTypes , InterestAccrualListUiState } from "./types";

const INSTRUMNET_INIT_STATE = {
  loading: false,
  data: {
    metadata: {
      totalCount: 0,
      currentPageRecords: 0,
      totalPages: 0,
      links: {
        self: null,
        first: null,
        previous: null,
        next: null,
        last: null
      }
    },
    records: []
  },
  error: null
};

const IntrumenetInterestAccrualsReducer = (state: InstrumentInterestAccrualReduxState = INSTRUMNET_INIT_STATE, action: InstrumentInterestAccrualReducerDispatch) => {
  switch (action.type) {
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUALS: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUALS_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUALS_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case InstrumentInterestAccrualReduxTypes.RESET:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};



const IntrumenetInterestAccrualReducer = (state: InstrumentInterestAccrualReduxState = INSTRUMNET_INIT_STATE, action: InstrumentInterestAccrualReducerDispatch) => {
  switch (action.type) {
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUAL: {
      return {
        ...state,
        data: action.payload.data,
        loading: true
      };
    }
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUAL_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false
      };
    }
    case InstrumentInterestAccrualReduxTypes.FETCH_INTEREST_ACCRUAL_ERROR: {
      return {
        ...state,
        error: action.payload.error,
        loading: false
      };
    }
    case InstrumentInterestAccrualReduxTypes.RESET:
      return {
        ...state,
        data: {
          metadata: {
            totalCount: 0,
            currentPageRecords: 0,
            totalPages: 0,
            links: {
              self: null,
              first: null,
              previous: null,
              next: null,
              last: null
            }
          },
          records: []
        },
        loading: false,
        error: false
      };
    default:
      return { ...state };
  }
};

const INTEREST_ACCRUAL_LIST_UI_INIT_STATE: InterestAccrualListUiState = {
  currentPage: 1,
  searchFilter: {
    stale: { value: "stale", label: "stale" }
  },
  sort: { field: "updatedOn", order: false },
  isFilterApplied: false
};

/** List UI state — intentionally ignores entity RESET so filters survive route changes */
const InterestAccrualListUiReducer = (
  state: InterestAccrualListUiState = INTEREST_ACCRUAL_LIST_UI_INIT_STATE,
  action: { type: string; payload?: Partial<InterestAccrualListUiState> }
) => {
  switch (action.type) {
    case InstrumentInterestAccrualReduxTypes.SET_INTEREST_ACCRUAL_LIST_UI:
      return {
        ...state,
        ...action.payload
      };
    case InstrumentInterestAccrualReduxTypes.RESET_INTEREST_ACCRUAL_LIST_UI:
      return { ...INTEREST_ACCRUAL_LIST_UI_INIT_STATE };
    default:
      return state;
  }
};

export {
  InterestAccrualListUiReducer, IntrumenetInterestAccrualsReducer ,IntrumenetInterestAccrualReducer};
